import React from "react";
import styles from "./Chat.module.css";
import firebase from "firebase/app";
import moment from "moment";
import "firebase/firestore";

const Thread = ({ thread, contact, user }) => {
  const [newMessage, setNewMessage] = React.useState("");
  const chatref = React.useRef();

  const scrollBottom = () => {
    chatref.current.scrollTop =
      chatref.current.scrollHeight - chatref.current.clientHeight;
  };

  const handlePress = (e) => {
    // console.log(e.key, e.keyCode);
    if ((e.key === "Enter" || e.keyCode === 13) && newMessage.length > 0) {
      setNewMessage("");
      const db = firebase.firestore();
      db.collection(`chat/${contact.thread}/thread`).add({
        time: new Date(),
        message: newMessage,
        user: user._id,
      });
    }
  };

  React.useEffect(() => {
    scrollBottom();
  }, [thread]);

  return (
    <div className={styles.threadWrapper}>
      <input
        className={styles.input}
        placeholder="Type a message"
        type="text"
        value={newMessage}
        onChange={(e) => setNewMessage(e.target.value)}
        onKeyPress={handlePress}
      />
      <div className={styles.thread} ref={chatref}>
        {thread &&
          thread.map((message) => (
            <div
              className={`${styles.message} ${
                user._id === message.user ? styles.self : ""
              }`}
            >
              <div className={styles.text}>{message.message}</div>
              <div className={styles.time}>
                {moment.unix(message.time.seconds).format("HH:mm")}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default Thread;
